angular.module('hj.imgCheck', []).directive('hjImgCheck', ['$window', '$http', '$log',
    function($window, $http, $log) {
        'use strict';
        return {
            priority: 0,
            restrict: 'A',
            link: function($scope, $element, $attr) {
                var count = 0;

                $element.on('load error', function() {
                    if (count > 1) {
                        return;
                    }

                    if (($element[0].naturalWidth === 0 || $element[0].naturalHeight === 0) &&
                        !($window.outerWidth === 0 && $window.outerHeight === 0) &&
                        !$window._phantom) {

                        purge($attr.src);

                    } else {
                        $attr.$set('data-width', $element[0].naturalWidth);
                        $attr.$set('data-height', $element[0].naturalHeight);
                        $attr.$set('data-ratio', ($element[0].naturalWidth / $element[0].naturalHeight).toFixed(2));
                        $attr.$set('data-orientation', $element[0].naturalWidth / $element[0].naturalHeight === 1 ?
                            'square' : $element[0].naturalWidth / $element[0].naturalHeight > 1 ? 'landscape' : 'portrait');
                    }

                    count++;
                });

                $element.on('click', function(e) {
                    if (e.altKey && e.shiftKey) {
                        e.preventDefault();

                        purge($attr.src);
                    }
                });

                var purge = function(url) {
                    $http({
                        method: 'GET',
                        url: '/api/cloudflare/purge',
                        params: {
                            url: url
                        }
                    }).error(function(data) {
                        $log.error(data);
                    });

                    $attr.$set('src', [$attr.src, $attr.src.indexOf('?') > -1 ? '&d' + count + '=' : '?d' + count + '=', +new Date()].join(''));
                };
            }
        };
    }
]);
